// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__203fl","row":"Node_row__2zOD-","label":"Node_label__HIX4l","footer":"Node_footer__3Qmz_"};